<template functional>
  <q-markup-table
    :ref="data.ref"
    flat
    bordered
    class="striped"
    :class="data.staticClass"
    :wrap-cells="props.wrapCells"
  >
    <thead>
      <slot name="table-head">
        <tr>
          <th v-for="column in props.columns" :key="column" class="text-muted">
            {{ column }}
          </th>
        </tr>
      </slot>
    </thead>

    <tbody>
      <slot />
    </tbody>

    <tfoot>
      <slot name="table-foot" />
    </tfoot>
  </q-markup-table>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    wrapCells: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
};
</script>
